import React from 'react';
import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

const GroupSummary = ({ groupedBids }) => {
  const { t } = useTranslation();

  // Get unique bid groups and their lots
  const bidGroups = {};
  Object.entries(groupedBids).forEach(([lot, lotData]) => {
    lotData.bids.forEach(bid => {
      if (bid.bids_group_name) {
        if (!bidGroups[bid.bids_group_name]) {
          bidGroups[bid.bids_group_name] = new Set();
        }
        bidGroups[bid.bids_group_name].add(lot);
        // Add alternative lots if they exist
        if (bid.alternative_bids) {
          bid.alternative_bids.forEach(altBid => {
            bidGroups[bid.bids_group_name].add(altBid.lot);
          });
        }
      }
    });
  });

  if (Object.keys(bidGroups).length === 0) return null;

  return (
    <Box mt={4} className="groupbids-summary">
      <Box display="inline-block">
        <span className="group-summary-label">{t('myBids.bidGroups')}:</span>
        {Object.entries(bidGroups).map(([group, lots], index) => (
          <span key={group} className="group-info">
            {index > 0 && <span className="dot">•</span>}
            {t('myBids.groupWithLots', {
              group: group.toUpperCase(),
              lots: Array.from(lots).sort((a, b) => a - b).join(', ')
            })}
          </span>
        ))}
      </Box>
    </Box>
  );
};

export default GroupSummary;